
  export function checkThamSo() {
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (ThamSo.length > 0 && userInfo != {}) {
      let data = [...ThamSo];
      let dataFilter = data.filter(state => {
        return Number(state.giaTri) == Number(userInfo.coQuanQuanLyId)
      })
      if (dataFilter.length > 0) {
        return dataFilter[0].ten
      } else {
        return null
      }
    } else {
      return null
    }
  }




// WEBPACK FOOTER //
// ./src/constants/checkThamSo.js